import { render, staticRenderFns } from "./IndicataCard.vue?vue&type=template&id=4c2c5188&"
import script from "./IndicataCard.vue?vue&type=script&lang=js&"
export * from "./IndicataCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports